import React, { useEffect, useState } from "react";
import Select from "react-select";
import { getPatientMarriageInfo } from "../../../services/PatientGapldService";
const GapldFormFields = ({ formData, setFormData }) => {
  const [marriageInfoList, setMarriageInfoList] = useState([]);
  const [loading, setLoading] = useState(true);

  // Fetch marriage info on mount
  useEffect(() => {
    if (!formData.patient_id) {
      setLoading(false);
      return;
    }

    getPatientMarriageInfo(formData.patient_id)
      .then((res) => {
        if (res.data?.status === "success") {
          const formattedOptions = res.data.data.map((item) => ({
            value: item.marriage_info_id,
            label: `${item.marriage_history} Marriage (${item.husband_or_spouse_name || "N/A"})`,
          }));
          setMarriageInfoList(formattedOptions);
        }
      })
      .catch((err) => console.error("Marriage Info fetch failed", err))
      .finally(() => setLoading(false));
  }, [formData.patient_id]);

  const deliveryOptionList = [
    { value: "Delivered", label: "Delivered" },
    { value: "Abortion", label: "Abortion" },
    { value: "Miscarriage", label: "Miscarriage" },
  ];  

  if (loading) return <p>Loading GAPLD fields...</p>;

  return (
    <div className="gapld-form-fields">
      {/* Pregnancy Status */}
      <div className="mb-3">
        <label className="form-label">Pregnancy Status<span style={{ color: "red" }}>*</span></label>
        <Select
          name="pregnancy_status"
          options={deliveryOptionList}
          value={deliveryOptionList.find(opt => opt.value === formData.pregnancy_status) || null}
          onChange={(selectedOption) =>
            setFormData(prev => ({ ...prev, pregnancy_status: selectedOption?.value || "" }))
          }
          placeholder="Select Pregnancy Status"
          isClearable
          required
        />
      </div>

      {/* Marriage History */}
      {/* <div className="mb-3">
        <label className="form-label">Marriage History<span style={{ color: "red" }}>*</span></label>
        <Select
          name="marriage_info_id"
          options={marriageInfoList}
          value={marriageInfoList.find(opt => opt.value === formData.marriage_info_id) || null}
          onChange={(selectedOption) =>
            setFormData(prev => ({ ...prev, marriage_info_id: selectedOption?.value || "" }))
          }
          placeholder="Select Marriage Info"
          isClearable
        />
      </div> */}

      {/* Abortion Fields */}
      {formData.pregnancy_status === "Miscarriage" && (
        <>
          <div className="mb-3">
            <label className="form-label">Miscarriage Date<span style={{ color: "red" }}>*</span></label>
            <input
              type="month"
              className="form-control"
              name="abortion_date"
              value={formData.abortion_date}
              onChange={(e) => setFormData(prev => ({ ...prev, abortion_date: e.target.value }))}
              max={new Date().toISOString().slice(0, 7)}
              required
            />
          </div>
          <div className="mb-3">
            <label className="form-label">Which RX helped to maintain pregnancy?</label>
            <input
              type="text"
              className="form-control"
              name="which_rx_helped"
              value={formData.which_rx_helped}
              onChange={(e) => setFormData(prev => ({ ...prev, which_rx_helped: e.target.value }))}
            />
          </div>
          <div className="mb-3">
            <label className="form-label">How did the miscarriage happen?</label>
            <input
              type="text"
              className="form-control"
              name="how_did_miscarriage_happen"
              value={formData.how_did_miscarriage_happen}
              onChange={(e) => setFormData(prev => ({ ...prev, how_did_miscarriage_happen: e.target.value }))}
            />
          </div>
          <div className="mb-3">
            <label className="form-label">Miscarriage Reason</label>
            <input
              type="text"
              className="form-control"
              name="miscarriage_reason"
              value={formData.miscarriage_reason}
              onChange={(e) => setFormData(prev => ({ ...prev, miscarriage_reason: e.target.value }))}
            />
          </div>
        </>
      )}
      {formData.pregnancy_status === "Abortion" && (
        <>
          <div className="mb-3">
            <label className="form-label">Abortion Date<span style={{ color: "red" }}>*</span></label>
            <input
              type="month"
              className="form-control"
              name="abortion_date"
              value={formData.abortion_date}
              onChange={(e) => setFormData(prev => ({ ...prev, abortion_date: e.target.value }))}
              max={new Date().toISOString().slice(0, 7)}
              required
            />
          </div>
          <div className="mb-3">
            <label className="form-label">Which RX helped to maintain pregnancy?</label>
            <input
              type="text"
              className="form-control"
              name="which_rx_helped"
              value={formData.which_rx_helped}
              onChange={(e) => setFormData(prev => ({ ...prev, which_rx_helped: e.target.value }))}
            />
          </div>
          {/* <div className="mb-3">
            <label className="form-label">How did the miscarriage happen?</label>
            <input
              type="text"
              className="form-control"
              name="how_did_miscarriage_happen"
              value={formData.how_did_miscarriage_happen}
              onChange={(e) => setFormData(prev => ({ ...prev, how_did_miscarriage_happen: e.target.value }))}
            />
          </div> */}
          {/* <div className="mb-3">
            <label className="form-label">Miscarriage Reason</label>
            <input
              type="text"
              className="form-control"
              name="miscarriage_reason"
              value={formData.miscarriage_reason}
              onChange={(e) => setFormData(prev => ({ ...prev, miscarriage_reason: e.target.value }))}
            />
          </div> */}
        </>
      )}
      {/* Delivery Fields */}
      {formData.pregnancy_status === "Delivered" && (
        <>
          <div className="mb-3">
            <label className="form-label">Delivery Date<span style={{ color: "red" }}>*</span></label>
            <input
              type="month"
              className="form-control"
              name="delivery_date"
              value={formData.delivery_date}
              onChange={(e) => setFormData(prev => ({ ...prev, delivery_date: e.target.value }))}
              max={new Date().toISOString().slice(0, 7)}
              required
            />
          </div>
          <div className="mb-3">
            <label className="form-label">How was the delivery?</label>
            <input
              type="text"
              className="form-control"
              name="How_was_the_delivery"
              value={formData.How_was_the_delivery}
              onChange={(e) => setFormData(prev => ({ ...prev, How_was_the_delivery: e.target.value }))}
            />
          </div>
          <div className="mb-3">
            <label className="form-label">Gender</label>
            <Select
              name="gender"
              options={[
                { value: "Male", label: "Male" },
                { value: "Female", label: "Female" },
                { value: "Transgender", label: "Transgender" },
              ]}
              value={formData.gender ? { value: formData.gender, label: formData.gender } : null}
              onChange={(selectedOption) =>
                setFormData(prev => ({ ...prev, gender: selectedOption?.value || "" }))
              }
              placeholder="Select Gender"
              isClearable
            />
          </div>
        </>
      )}
    </div>
  );
};

export default GapldFormFields;
